import { defineComponent, h } from 'vue';
import { QBtn, QInput, QSelect, QIcon } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import util from '../../careHelpfulFunctions.jsx';
import { Container, Draggable } from 'vue3-smooth-dnd';

const SchemaItem = defineComponent({
    name: 'schema-item',
    components: {
        QBtn,
        QInput,
        QSelect,
        QIcon,
        Container,
        Draggable,
    },
    data: () => ({
        schema: null,
        list: null,
        localvalue: null,
        localName: '',
    }),
    props: {
        name: null,
        cmodel: null,
        typeSchema: null,
        renamed: null,
        changed: null,
        deleted: null,
        moveup: null,
        movedown: null,
        selected: null,
        setselection: null,
        navigateTo: null,
        canNavigate: false,
        propertygrid: false,
    },
    async created() {
        if (this.typeSchema) {

            const s = await utils.schema.get(this.typeSchema);
            this.schema = utils.schema.resolve_Of(s);
        }
        this.list = await utils.schema.get('/Apps/Schema/AnyOf/schema/public/Platform.Schema.BaseTypes.v1/SchemaSchema');

        if (this.schema)
            for (let i = 0; i < this.list.anyOf.length; i++) {
                const opt = this.list.anyOf[i];

                if (this.schema && (this.schema.title === opt.title)) {
                    this.localvalue = opt.Id;
                    //console.log(`SchemaProperties created detecting value; name:${this.name}, value:${value}, title:${opt.title}`);
                }
            }
        this.localName = this.name ?? '';
    },
    methods: {
        onChanged(name, value) {
            let strvalue;
            if (typeof value === 'string')
                strvalue = value;
            else
                strvalue = JSON.stringify(value);

            console.log(`SchemaProperties changed; name:${name}, value:${strvalue}`);
            this.localvalue = value;
            this.changed(name, value);
        },
    },
    render() {
        if (!this.list)
            return null;

        const options = [];
        //let value;
        //let selected = false;
        for (let i = 0; i < this.list.anyOf.length; i++)
        {
            const opt = this.list.anyOf[i];

            //if (this.schema && (this.schema.title === opt.title))
            //{
                //value = opt.Id;
                //selected = true;
                //console.log(`SchemaProperties render detecting value; name:${this.name}, value:${value}, title:${opt.title}`);
            //}
            options.push({ text: opt.title, value: opt.Id, disabled: false });
        }
        options.sort((a, b) => a.text.localeCompare(b.text));

        //if (!selected)
        if (!this.localvalue)
            options.splice(0, 0, { text: "Please select one", value: "", disabled: true });

        let select_checkbox;
        let navigate;
        if (this.canNavigate && this.typeSchema) {
            select_checkbox = <input type="checkbox" checked={this.name in this.selected} onChange={(e) => this.setselection(this.name, e.target.checked)} />;
            navigate = <QBtn flat size="sm" padding="xs sm" color="blue-4" icon="mdi-open-in-new" title="Edit" onClick={() => this.navigateTo(this, this.name)} />;
        }

        const btn_styles = {
            'font-size': "x-small"
        };

        return (
            <tr>
                <td style={{ width: "50%", ...(this.propertygrid ? { minWidth: 0 } : {}) }}>
                    <span class="property-grid" style={{ whiteSpace: "nowrap", display: "flex", flexDirection: "row", alignItems: "center"  }}>
                        {select_checkbox}
                        {navigate}
                        <QInput style="flex-grow: 1;" outlined dense hide-bottom-space modelValue={this.localName} onUpdate:modelValue={(value) => this.localName = value} onBlur={() => this.renamed(this.name, this.localName)} />
                    </span>
                </td>
                <td class="property-grid" style={{ width: "50%", ...(this.propertygrid ? { minWidth: 0 } : {}) }}>
                    <QSelect outlined dense hide-bottom-space style={{ width: "100%", ...(this.propertygrid ? { minWidth: 0 } : {}) }}
                        popup-content-class="q-select-max-popup-height"
                        options={options}
                        option-label="text"
                        option-value="value"
                        emit-value
                        map-options
                        modelValue={this.localvalue}
                        onUpdate:modelValue={(value) => this.onChanged(this.name, value)} />
                </td>
                <td class="property-grid" style={{ whiteSpace: "nowrap", ...(this.propertygrid ? { minWidth: 0 } : {}) }}>
                    <QBtn flat size="sm" dense padding="xs xs" color="grey-8" icon="mdi-arrow-up" title="Move Up" style={btn_styles} onClick={() => this.moveup(this.name)} />
                    <QBtn flat size="sm" dense padding="xs xs" color="grey-8" icon="mdi-arrow-down" title="Move Down" style={btn_styles} onClick={() => this.movedown(this.name)} />
                    <QBtn flat size="sm" dense padding="xs xs" color="grey-8" icon="mdi-close" title="Delete" style={btn_styles} onClick={() => this.deleted(this.name)} />
                </td>
            </tr>
        );
    }
});

export default defineComponent({
    name: 'schema-properties',
    components: {
        QBtn,
        QIcon,
        SchemaItem
    },
    data: () => ({
        selected: {},
    }),
    computed: {
        ...utils.forms.computed,
        anySelected: function () {
            return Object.keys(this.selected).length > 0;
        }
    },
    props: {
        name: '',
        schema: null,
        schemakey: null,
        root: null,
        cmodel: null,
        navigate: null,
        canNavigate: false,
        propertygrid: false,
    },
    methods: {
        async itemChanged(prop, value) {
            let s = await utils.schema.get(value);
            s = utils.schema.resolve_Of(s);
            const m = utils.schema.getDefaultModel(s);
            this.cmodel[this.schemakey][prop] = m;
        },
        itemRenamed(prop, value) {
            if (prop == value)
                return; // Don't do anything, the name didn't change

            const oldobj = this.cmodel[this.schemakey];
            if (value in oldobj) {
                alert('Property ' + value + ' is already used');
                return; // Can't rename to the name of an existing property
            }
            const properties = util.renameProperty(oldobj, prop, value);
            this.cmodel[this.schemakey] = properties;
        },
        itemDeleted(prop) {
            delete this.cmodel[this.schemakey][prop];
        },
        addAnother() {
            const properties = this.cmodel[this.schemakey]; 
            let key = 'Unnamed';
            let dup = 1;
            while (key in properties)
                key = 'Unnamed_' + (dup++);

            properties[key] = { $objectId: utils.generateUUID() };
        },
        moveDown(prop) {
            const properties = this.cmodel[this.schemakey];
            const newobj = util.reorderProperty(properties, prop, 1);
            console.log(`${JSON.stringify(Object.keys(newobj))}`);
            this.cmodel[this.schemakey] = newobj;
        },
        moveUp(prop) {
            const properties = this.cmodel[this.schemakey];
            const newobj = util.reorderProperty(properties, prop, -1);
            console.log(`${JSON.stringify(Object.keys(newobj))}`);
            this.cmodel[this.schemakey] = newobj;
        },
        reOrderItems(res) {
            console.log('reOrderItems');
            console.log(JSON.stringify(res));
        },
        setSelection(name, checked) {
            if (checked)
                this.selected[name] = checked;
            else
                delete this.selected[name];
        },
        copy() {
            const properties = this.cmodel[this.schemakey];
            const selected = [];
            for (let key in this.selected)
                selected.push({ key: key, value: properties[key] });

            localStorage.setItem('careClipboard', JSON.stringify(selected));
        },
        cut() {
            const properties = this.cmodel[this.schemakey];
            const selected = [];
            for (let key in this.selected) {
                selected.push({ key: key, value: properties[key] });
                delete properties[key];
            }

            localStorage.setItem('careClipboard', JSON.stringify(selected));

            this.selected = {};
        },
        paste() {
            const rawbuffer = localStorage.getItem('careClipboard');
            if (rawbuffer && typeof rawbuffer === 'string') {
                try {
                    const data = JSON.parse(rawbuffer);
                    if (typeof data === 'object' && Array.isArray(data)) {
                        if (!this.cmodel[this.schemakey])
                            this.cmodel[this.schemakey] = {};

                        const properties = this.cmodel[this.schemakey];
                        for (let i = 0; i < data.length; i++) {
                            const item = data[i];
                            if (!('key' in item && 'value' in item)) continue;

                            let key = item.key;
                            let dup = 1;
                            while (key in properties)
                                key = item.key + '_' + (dup++);

                            if (item.value.$objectId)
                                item.value.$objectId = utils.generateUUID();

                            properties[key] = item.value;
                        }
                    }
                }
                catch (e) {
                    alert('Failed to parse data from clipboard buffer: ' + e);
                }
            }
        },
        selectAll() {
            const properties = this.cmodel[this.schemakey];
            for (let key in properties)
                this.selected[key] = true;
        },
        selectNone() {
            this.selected = {};
        },
    },
    render() {
        const elements = [];
        const cmodel = this.cmodel[this.schemakey];
        let i = 0;
        for (let key in cmodel) {
            if (key.substr(0, 1) === '$') continue;
            const item = cmodel[key];

            elements.push(
                <SchemaItem
                    key={item.$objectId + '_' + key}
                    name={key}
                    cmodel={cmodel}
                    typeSchema={item.$typeSchema}
                    changed={(prop, value) => this.itemChanged(prop, value)}
                    renamed={(prop, value) => this.itemRenamed(prop, value)}
                    deleted={(prop, value) => this.itemDeleted(prop, value)}
                    moveup={(prop) => this.moveUp(prop)}
                    movedown={(prop) => this.moveDown(prop)}
                    selected={this.selected}
                    setselection={(prop, checked) => this.setSelection(prop, checked)}
                    navigateTo={(control, prop) => this.navigate(control, prop, item)}
                    canNavigate={this.canNavigate}
                    propertygrid={this.propertygrid}>
                </SchemaItem>);
        }

        const btn_styles = {
            'font-size': "x-small"
        };
        const selections = (
            <span class="property-grid" style="display:flex; gap: 5px;">
                <QBtn dense size="sm" class="q-px-sm" color="grey-8" text-color="white" style={btn_styles} disable={!this.anySelected} onClick={this.copy}>Copy</QBtn>
                <QBtn dense size="sm" class="q-px-sm" color="grey-8" text-color="white" style={btn_styles} disable={!this.anySelected} onClick={this.cut}>Cut</QBtn>
                <QBtn dense size="sm" class="q-px-sm" color="grey-8" text-color="white" style={btn_styles} onClick={this.paste}>Paste</QBtn>

                <QBtn dense size="sm" class="q-px-sm" color="grey-8" text-color="white" style={btn_styles} onClick={this.selectAll}>Select All</QBtn>
                <QBtn dense size="sm" class="q-px-sm" color="grey-8" text-color="white" style={btn_styles} onClick={this.selectNone}>Select None</QBtn>
            </span>
        );

        return (
            <table style={{ width: "100%", borderStyle: "solid", borderColor: "silver", borderWidth: "1px" }}>
                <tr>
                    <td colspan="3">
                        {selections}
                    </td>
                </tr>
                <tr>
                    <th>Property Name</th>
                    <th>Property Type</th>
                </tr>
                {elements}
                <tr>
                    <td colspan="3" class="property-grid" style={this.propertygrid ? { minWidth: 0 } : undefined}>
                        <QBtn dense size="sm" padding="xs sm" color="grey-8" text-color="white" class="c-SentenceCaseButton" no-caps onClick={() => this.addAnother()} icon="mdi-plus"><span>Add Another</span></QBtn>
                    </td>
                </tr>
            </table>
        );
    }
});
/*
                <Draggable key={item.$objectId + '_' + key} index={i++} style="width: 100%;">

                <Container onDrop={(res) => this.reOrderItems(res)} drag-handle-selector=".column-drag-handle">
                    {elements}
                </Container>

*/